import React from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES} from "rn-responsive-styles";
import LoanIcon from "../assets/images/tripInsurance.png";
import InsuranceIcon from "../assets/images/insurance-card-icon.png";
import AllignedServices from "../assets/images/allignedServices.png";
import { FONTS } from "../constant";

export default function CTabCard(otherProps) {
  const styles = useStyles();
  const isSelected = otherProps.isSelected || false;
  const type = otherProps.type || "loan";

  const tabData = {
    insurance: {
      heading: "Insurance",
      description: "we've got you covered",
      image: InsuranceIcon,
      activeImage: InsuranceIcon,
    },
    loan: {
      heading: "Loans",
      description: "Simple,reliable,Quick money",
      image: LoanIcon,
      activeImage: LoanIcon,
    },
    alignedServices: {
      heading: "FASTag MAX",
      description: "Other services by FirstForward",
      image: AllignedServices,
      activeImage: AllignedServices,
    },
  };

  return (
    <TouchableOpacity
      style={!isSelected ? styles.CTabCard : styles.CTabCardSelected}
      onPress={() => otherProps.onPress()}
    >
      <View>
        <Text
          style={
            !isSelected
              ? [styles.headingTextStyle, { color: "white",fontSize:15 }]
              : [styles.headingTextStyle,{fontSize:15}]
          }
        >
          {tabData[type]?.heading}
        </Text>
        <Text
          style={
            !isSelected
              ? [styles.headingTextStyle, { color: "white" }]
              : styles.headingTextStyle
          }
        >
          {tabData[type]?.description}
        </Text>
      </View>
      <Image source={tabData[type]?.image} style={styles.iconWrapper} />
    </TouchableOpacity>
  );
}


const useStyles = CreateResponsiveStyle(
  {
    CTabCard: {
      flexDirection: "row",
      width: '32.1%',
      height: 73.3,
      backgroundColor: "#c32b2c",
      borderRadius: 10,
      justifyContent: "space-between",
      alignItems: "center",
      padding: 10,
    },
    tabWrapper: { alignItems: "center" },
    iconWrapper: { width: 22.3, height: 25.5,resizeMode:"contain" },
  
    CTabCardSelected: {
      flexDirection: "row",
      width: '32.1%',
      height: 73.3,
      backgroundColor: "white",
      borderRadius: 10,
      justifyContent: "space-between",
      alignItems: "center",
      padding: 10,
    },
    tabWrapperSelected: { alignItems: "center" },
    iconWrapperSelected: { width: 22.3, height: 25.5 },
    headingTextStyle: {
      fontFamily: FONTS.Inter,
      fontSize: 13,
      color: "#6c6c6c",
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      CTabCard:{
        width:300
      },
      CTabCardSelected:{
        width:300
      }
    },
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
      tabWrapper: {
        flexDirection: "column",
      },
      CTabCard:{
        width:'98%',
        marginLeft:-5
      },
      CTabCardSelected:{
        width:'98%',
        marginLeft:-5
      }
     
    },
  }
);

